const get_ajax_url = () => site_vars.ajax_url;
const get_nonce = () => site_vars.nonce;
const get_post_id = () => site_vars.post_id;
const get_error_message = (key) => $("#error-message-" + key + "").addClass('active');
const get_img_url = () => site_vars.img_url;
const get_permalink = () => site_vars.permalink;
const get_service_simply_book = () => site_vars.service_simply_book;
const get_status_simply_book = () => site_vars.status_simply_book;
const get_template_name = () => site_vars.template_name;
const get_domain = () => site_vars.domain;
const get_domain_uppercase = () => site_vars.domain_uppercase;
const get_img_url_general = () => site_vars.img_general_url;
const get_algolia_user_index = () => site_vars.algolia_user_index;
const get_algolia_api_search_key = () => site_vars.algolia_api_search_key;
const get_algolia_app_id = () => site_vars.algolia_app_id;
const get_algolia_lead_index = () => site_vars.algolia_lead_index;
const get_algolia_task_ids = () => site_vars.algolia_task_ids;
const get_algolia_api_wait_key = () => site_vars.algolia_api_wait_key;
const get_domain_name = () => site_vars.domain_name;
const get_algolia_indexes = (index) => site_vars.algolia_indexes[index];
const get_firebase_config = () => site_vars.firebase_config;
const get_js_translations = () => site_vars.js_translations;
const get_locale = () => site_vars.locale;
export default {
    get_ajax_url,
    get_nonce,
    get_post_id,
    get_error_message,
    get_img_url,
    get_permalink,
    get_service_simply_book,
    get_status_simply_book,
    get_template_name,
    get_domain,
    get_domain_uppercase,
    get_img_url_general,
    get_algolia_user_index,
    get_algolia_api_search_key,
    get_algolia_app_id,
    get_algolia_lead_index,
    get_algolia_task_ids,
    get_algolia_api_wait_key,
    get_algolia_indexes,
    get_domain_name,
    get_firebase_config,
    get_js_translations,
    get_locale,
};